import VideoPlayer from 'components/VideoPlayer';
import { useGetContent } from 'contexts/Content';
import { useParams } from 'react-router-dom';

const VideoPage = () => {
  const { care_id, video_id } = useParams();
  const content = useGetContent(care_id as string);

  if (!content) {
    return null;
  }
  const targetVideo = content?.articles.find(
    video => video.id === (video_id as string),
  );

  if (!targetVideo || !video_id) {
    return null;
  }
  const {
    author,
    authorTitle,
    time,
    equipment,
    goal,
    title,
    authorAvatar,
    authorAvatarAlt,
  } = targetVideo;

  return (
    <VideoPlayer
      videoId={video_id}
      phase={content.phase}
      authorTitle={authorTitle!}
      author={author}
      time={time!}
      equipment={equipment!}
      goal={goal!}
      title={title}
      careId={care_id!}
      avatar={authorAvatar!}
      avatarAlt={authorAvatarAlt!}
    />
  );
};

export default VideoPage;
